import * as styles from "src/components/DropZoneInputV2/components/PreviewRow/PreviewRow.style.ts";
import { IconButtonV2 } from "src/components/IconButtonV2/IconButtonV2.tsx";
import { TrashIcon } from "src/lib/ui-icon-v2";
import type { MediaObject } from "src/components/DropZoneInputV2/types.ts";
import Drop from "./drop.svg?react";

export const PreviewRowForDragLayer = ({ object }: { object: MediaObject }) => {
  const imageName = object.attributes.name;

  const url =
    object.attributes.preview_url ||
    object.attributes.original_url ||
    // object.client_preview || it is not working right for .csv files
    undefined;

  return (
    <div
      css={styles.root({
        isDragging: false,
      })}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        title={"Drag"}
        className={"drop"}
        css={styles.drop({
          isDragging: true,
        })}
      >
        <Drop />
      </button>
      {url && (
        <div css={styles.imageContainer}>
          <img src={url} alt={imageName} css={styles.image} />
        </div>
      )}

      <span css={styles.placeholder}>{imageName}</span>

      <IconButtonV2
        size="sm"
        skin="danger"
        variant="outlined"
        type="button"
        css={styles.removeButton}
      >
        <TrashIcon />
      </IconButtonV2>
    </div>
  );
};
